import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'

import { Row, Container, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import access from '../../../utils/access'

import style from './style'

const PATH_PREFIX = 'dashboard'
const routes = [
  {
    title: `News`,
    path: `/news`
  },
  {
    title: `Dashboard`,
    path: `/statistics`
  },
  {
    title: `Community`,
    path: `/community`
  },
  {
    title: `Help Desk`,
    path: `/support`
  },
  {
    title: `User`,
    path: `/user`
  },
  {
    title: `Settings`,
    path: `/settings`,
    access: access.modSettings
  }
]

@inject('User')
@observer
export class DashboardNavigation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  onCollapseClick (e) {
    e.preventDefault()

    this.setState({
      ...this.state,
      collapse: !this.state.collapse
    })
  }

  render () {
    return (
      <Row className={css(style.list.wrapper)}>
        <Container>
          <Row>
            <Col xs='auto' className={`d-flex d-lg-none align-items-center`}>
              <button
                className={css(style.navbar.collapseButton)}
                onClick={this.onCollapseClick.bind(this)}
              >
                <i className={`fa fa-bars`} />
              </button>
            </Col>
          </Row>
          <Row>
            <Col
              className={css(
                style.navbar.wrapper,
                this.state.collapse ? style.navbar.mobileShow : null
              )}
            >
              <ul
                className={`d-flex flex-column flex-lg-row ${css(
                  style.list.list
                )}`}
              >
                {routes.map((r, index) => {
                  if (
                    r.access &&
                    (!this.props.User.me.permissions ||
                      !r.access(this.props.User.me.permissions))
                  ) {
                    return null
                  }

                  return (
                    <RenderListItem
                      key={`index_${r.title}`}
                      isActive={this.props.history.location.pathname.startsWith(
                        `/${PATH_PREFIX}${r.path}`
                      )}
                      title={r.title}
                      path={r.path}
                    />
                  )
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </Row>
    )
  }
}

const RenderListItem = props => (
  <li className={css(style.list.item)}>
    <Link
      to={`/dashboard${props.path}`}
      className={`
        d-flex flex-column
        ${css(style.list.itemLink)}
        ${props.isActive ? css(style.list.activeLink) : ''}
      `}
    >
      <span>{props.title}</span>
    </Link>
  </li>
)

export default DashboardNavigation



// WEBPACK FOOTER //
// ./src/components/partials/DashboardNavigation/index.js